import { tryGetHostApi } from "./externalApi";
import { isFeatureEnabled } from "./VelocityApi";
export async function getIsWidgetsRestrictedDataSharingEnabled() {
    // Default - Windows data is shared with WebXT
    let isPolicyEnabled = false;
    if (isFeatureEnabled("Feature_DMARestrictDataSharing") || isFeatureEnabled("Feature_DMARestrictDiagnosticData")) {
        const dashboardHostApi = await tryGetHostApi("DMAPolicyEvaluator", 4, 4);
        if (dashboardHostApi) {
            isPolicyEnabled = !!await dashboardHostApi.isWidgetsRestrictedDataSharingEnabled;
        }
    }
    return isPolicyEnabled;
}
export async function getIsWidgetsRestrictedThirdPartyDataSharingEnabled() {
    // Default - 3P data is shared with WebXT
    let isPolicyEnabled = false;
    if (isFeatureEnabled("Feature_DMARestrictDataSharing")) {
        const dashboardHostApi = await tryGetHostApi("DMAPolicyEvaluator", 1, 1);
        if (dashboardHostApi) {
            isPolicyEnabled = !!await dashboardHostApi.isWidgetsRestrictedThirdPartyDataSharingEnabled;
        }
    }
    return isPolicyEnabled;
}
export async function getIsWidgetsFirstPartyExperienceOptimizationEnabled() {
    // Default - Make 1P optimizations to the dashboard is enabled
    let isPolicyEnabled = true;
    if (isFeatureEnabled("Feature_DMA1POptimization")) {
        const dashboardHostApi = await tryGetHostApi("DMAPolicyEvaluator", 2, 2);
        if (dashboardHostApi) {
            isPolicyEnabled = !!await dashboardHostApi.isWidgetsFirstPartyExperienceOptimizationEnabled;
        }
    }
    return isPolicyEnabled;
}
export async function getIsWidgetsTaskbarAnnouncementsEnabled() {
    // Default - AEP rotation is enabled, same as hostapp.
    let isPolicyEnabled = true;
    if (isFeatureEnabled("Feature_DMADisableAnnouncementsAndBadges")) {
        const dashboardHostApi = await tryGetHostApi("DMAPolicyEvaluator", 3, 3);
        if (dashboardHostApi) {
            isPolicyEnabled = !!await dashboardHostApi.isWidgetsTaskbarAnnouncementsEnabled;
        }
    }
    return isPolicyEnabled;
}
export async function getIsWidgetsTaskbarBadgesEnabled() {
    // Default - AEP badging is enabled, same as hostapp.
    let isPolicyEnabled = true;
    if (isFeatureEnabled("Feature_DMADisableAnnouncementsAndBadges")) {
        const dashboardHostApi = await tryGetHostApi("DMAPolicyEvaluator", 3, 3);
        if (dashboardHostApi) {
            isPolicyEnabled = !!await dashboardHostApi.isWidgetsTaskbarBadgesEnabled;
        }
    }
    return isPolicyEnabled;
}
